import { UserSettingId } from 'src/graphql/entities/user-setting-value/user-setting-value.types';
import { useUserSetting } from './use-user-setting';

/**
 * `undefined` means the user has never answered — the composer's one-time
 * "Start folded next time?" offer is shown only in that state.
 */
export function useComposerStartFoldedSetting(): readonly [
  boolean | undefined,
  (next: boolean) => void,
] {
  return useUserSetting<boolean | undefined>(UserSettingId.ComposerStartFolded, {
    valueType: 'boolean',
    decode: (raw) => (typeof raw === 'boolean' ? raw : undefined),
    encode: (next) => (next ? 'true' : 'false'),
  });
}
